import { useState, useEffect } from 'react';

interface StickyQuoteBarProps {
  productName: string;
  onQuoteClick: () => void;
}

export default function StickyQuoteBar({ productName, onQuoteClick }: StickyQuoteBarProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 420);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-yellow-400 px-4 py-3 md:py-4">
      <div className="max-w-[1420px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-center sm:text-left">
          <p className="text-xs text-gray-500 hidden sm:block">Interested in this product?</p>
          <p className="text-sm font-black text-gray-900 truncate max-w-xs md:max-w-md">{productName}</p>
        </div>
        <div className="flex gap-3 w-full sm:w-auto">
          <a
            href="https://wa.me/8617671262710"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-5 py-2.5 border-2 border-gray-900 text-gray-900 font-bold text-sm rounded-md hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base" />
            <span className="hidden sm:inline">WhatsApp</span>
            <span className="sm:hidden">WhatsApp</span>
          </a>
          <button
            onClick={onQuoteClick}
            className="flex-1 sm:flex-none px-6 py-2.5 bg-yellow-400 text-gray-900 font-black text-sm rounded-md hover:bg-yellow-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            Get a Quote
          </button>
        </div>
      </div>
    </div>
  );
}
